import { render, staticRenderFns } from "./ProgramSponsorPostulations.vue?vue&type=template&id=0edc759a&"
import script from "./ProgramSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./ProgramSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports